module.exports = {
    port: 3000,
    EXTERNAL_BASE_URL: 'https://signature.netpeaksoftware.com/api/v1',
    NETPEAKSOFTWARE_BASE_URL: 'https://netpeaksoftware.com',
    aws: {
        accessKeyId: process.env.AMAZON_S3_KEY,
        secretAccessKey: process.env.AMAZON_S3_SECRET,
        region: "eu-west-2",
        Bucket: 'netpeaksoftware',
        ACL: 'public-read',
        baseUrl: 'https://static.netpeaksoftware.com/',
        path: 'dev03/uploads/image/signature/'
    }
};